export enum StudentRequestCardStatus {
  PENDING,
  ACCEPTED,
  CANCELED,
}
